import React from 'react';

import { Icon, TabBar } from 'ui/component';
import classNames from './EABD2CaseHeader.module.scss';

export interface CaseHeaderProps
  extends Readonly<{
    tabs: string[];
    activeTabIndex: number;
    onHomeIconButtonPress: () => void;
    onTabSelect: (tabIndex: number) => void;
  }> {}

export const CaseHeader = React.memo<CaseHeaderProps>((props) => {
  const { tabs, activeTabIndex, onHomeIconButtonPress, onTabSelect } = props;

  return (
    <div className={classNames.root}>
      <button onClick={onHomeIconButtonPress} type={'button'} aria-label={'Home'} className={classNames.iconButton}>
        <div className={classNames.iconWrapper}>
          <Icon type={'home'} />
        </div>
      </button>
      <div className={classNames.tabBarWrapper}>
        <TabBar tabs={tabs} activeTabIndex={activeTabIndex} onSelect={onTabSelect} />
      </div>
    </div>
  );
});
